import { GameUiModule } from './game-module';
import { kingOfTokyoUiModule } from '../king-of-tokyo/module';
import { catanUiModule } from '../catan/module';

/**
 * Every game the client knows how to host. Adding a game means adding its
 * module here (and nothing else — the route, home screen and create screen all
 * read this list).
 */
const modules: GameUiModule<unknown>[] = [
  kingOfTokyoUiModule,
  catanUiModule,
];

export function getGameModule(
  gameType: string,
): GameUiModule<unknown> | undefined {
  return modules.find((module) => module.gameType === gameType);
}

export function getGameModules(): GameUiModule<unknown>[] {
  return modules;
}
